import * as React from 'react';

export const PlayArrowIcon = ({ className }: { className?: string }) => (
  <svg width="96" height="96" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M11.3332 11.5201L18.3598 16.0001L11.3332 20.4801V11.5201ZM8.6665 6.66675V25.3334L23.3332 16.0001L8.6665 6.66675Z"
      fill="currentColor"
    />
  </svg>
);
